<!--  -->
<template>
  <div>
    <!--  -->
    <transition name="slide-up">
      <div v-if="isModalVisible" class="BottomModalMenu" :style="{ height: modalHeight + 'px' }">
        <div class="BottomModalMenu_HeaderArea">
          <div class="BottomModalMenu_Title">{{ modalTitle }}</div>
          <div class="BottomModalMenuCloseBtn">
            <b-icon icon="chevron-double-down" @click="closeModal"></b-icon>
          </div>
          <div></div>
        </div>
        <div class="BottomModalMenu_ContentArea">
          <div class="BottomModalMenu_MenuContnt">
            <div
              v-for="(modalMenuItem, modalMenuItemIndex) in modalMenuList"
              :key="modalMenuItemIndex"
              class="BottomModalMenu_MenuButton"
            >
              {{ modalMenuItem.menuLabel }}
            </div>
          </div>
        </div>
      </div>
    </transition>
    <!--  -->
    <div class="WorkM_BottomMenu">
      <div class="WorkM_BottomMenuContainer">
        <b-link
          v-for="(menuItem, menuItemIndex) in bottomMenuItems"
          :key="menuItemIndex"
          class="WorkM_BottomMenuItem"
          @click="clickMenu(menuItem.modalTitle, menuItem.modalMenuList)"
          :disabled="((systemAuthorityType == null || systemAuthorityType == 0) && menuItem.modalMenuList[0].menuPath == '/Approval')"
          :class="{'WorkM_BottomMenuItem_Disabled':((systemAuthorityType == null || systemAuthorityType == 0) && menuItem.modalMenuList[0].menuPath == '/Approval')}"
        >
          <div>
            <b-icon :icon="menuItem.bottomIcon" class="WorkM_BottomeMenuIcon"></b-icon>
          </div>
          <div class="WorkM_BottomeMenulabel">{{ menuItem.bottomLabel }}</div>
        </b-link>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  name: "BottomMenu",
  components: {},
  props: {
    value: {},
  },
  data: function () {
    return {
      bottomMenuItems: [
        {
          bottomLabel: "ホーム",
          bottomIcon: "house",
          modalTitle: "ホーム",
          modalMenuList: [{ menuLabel: "ホーム", menuPath: "/Home" },],
        },
        {
          bottomLabel: "報告",
          bottomIcon: "file-earmark-spreadsheet",
          modalTitle: "報告",
          modalMenuList: [{ menuLabel: "報告", menuPath: "/WorkRegist" },],
        },
        {
          bottomLabel: "カレンダー",
          bottomIcon: "calendar3",
          modalTitle: "カレンダー",
          modalMenuList: [{ menuLabel: "カレンダー", menuPath: "/WorkCalendar" },],
        },
        {
          bottomLabel: "事前申請",
          bottomIcon: "file-earmark-arrow-up",
          modalTitle: "事前申請",
          modalMenuList: [{ menuLabel: "事前申請", menuPath: "/ApplicationRegist" },],
        },
        {
          bottomLabel: "承認",
          bottomIcon: "person-check-fill",
          modalTitle: "承認",
          modalMenuList: [{ menuLabel: "承認", menuPath: "/Approval" },],
        },
      ],
      isModalVisible: false,
      modalHeight: 500,
      modalTitle: "",
      modalMenuList: [],
      systemAuthorityType: 0,
    };
  },
  mounted: function(){
    this.systemAuthorityType = this.$store.state.system_authority_type;
    console.debug("systemAuthorityType：" + this.systemAuthorityType);
  },
  computed: {
    inputedValue: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit("input", newValue);
      },
    },
  },
  methods: {
    clickMenu: function (title, menuList) {
      this.modalTitle = title;
      this.modalMenuList = menuList;
      let modalMenuSize = menuList.length;
      console.log(modalMenuSize);
      if (modalMenuSize <= 0) {
      } else if (modalMenuSize == 1) {
        this.$router.push(menuList[0].menuPath);
      } else {
        this.modalHeight = 65 * Math.ceil(modalMenuSize / 2) + 50;
        this.isModalVisible = true;
      }
    },
    // openMenu: function () {
    //   this.$refs.bottomMenuModal.openModal();
    // },
    closeModal() {
      this.isModalVisible = false;
    },
  },
};
</script>

<style>
.WorkM_BottomMenu {
  position: fixed;
  bottom: 0;
  width: 100%;
  background-color: var(--mainColor);
  box-shadow: 0 -1px 5px rgba(0, 0, 0, 0.1);
}
.WorkM_BottomMenuContainer {
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 0.2rem 0.7rem;
  /* padding: 0 1rem; */
}
.WorkM_BottomMenuItem {
  color: white;
  text-decoration: none;
  text-align: center;
  width: 4rem;
  min-width: 2rem;
  margin: 0 0.5rem;
  /* padding: 0.2rem 0rem; */
}
.WorkM_BottomMenuItem_Disabled {
  color:gray !important;
}
.WorkM_BottomeMenuIcon {
  font-size: 0.9rem;
}
.WorkM_BottomeMenulabel {
  font-size: 0.6rem;
  white-space: nowrap;
  text-align: center;
}

.WorkM_BottomMenuItem:hover {
  color: #f2f6fa;
}

/*
  ボトムメニュ　モーダル 
*/
.BottomModalMenu {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background: rgb(238, 238, 238);
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.2);
  overflow-y: auto;
  transition: height 0.3s ease;
}

.BottomModalMenu_HeaderArea {
  width: 100%;
  display: flex;
  justify-content: space-between;
  background: rgb(66, 66, 70);
  color: white;
}

.BottomModalMenu_Title {
  font-size: 1rem;
  flex-grow: 1;
  padding: 0.3rem 0.5rem;
}
.BottomModalMenuCloseBtn {
  font-size: 1.3rem;
  cursor: pointer;
  text-align: right;
  padding: 0 0.5rem;
}

.BottomModalMenu_MenuContnt {
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 0.5rem;
}
.BottomModalMenu_MenuButton {
  font-size: 0.8rem;
  width: 45%;
  margin: 0.2rem;
  padding: 0.2rem;
  background: white;
}

.slide-up-enter-active,
.slide-up-leave-active {
  transition: transform 0.3s ease;
}

.slide-up-enter,
.slide-up-leave-to {
  transform: translateY(100%);
}
</style>
